/* eslint-disable @typescript-eslint/member-ordering */

import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize, switchMap } from 'rxjs/operators';

import { UsersService } from '../../services/users.service';

import AdminHelpers from '../../helpers/helpers';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-add-admin-user-modal',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './add-admin-user-modal.component.html',
})
export class AddAdminUserModalComponent {
  isSubmitting: boolean;
  email: string;

  usersService: UsersService;
  toastr: ToastrService;
  modal: NgbActiveModal;
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.usersService = inject(UsersService);
    this.toastr = inject(ToastrService);
    this.modal = inject(NgbActiveModal);
  }

  public save(f: NgForm): void {
    if (f.invalid) {
      AdminHelpers.markFormInvalidAndFocus(f);
      return;
    }

    this.isSubmitting = true;
    f.form.disable();

    this.usersService
      .getUserModel(this.email)
      .pipe(
        switchMap((user) => this.usersService.setUserAsSuperAdmin(user.id)),
        finalize(() => {
          this.isSubmitting = false;
          f.form.enable();
          this.changeDetectorRef.markForCheck();
        })
      )
      // eslint-disable-next-line sonarjs/deprecation
      .subscribe(
        () => {
          this.toastr.success('The user has been assigned as a user admin');
          this.modal.close();
        },
        (err: unknown) => {
          const httpErr = err as HttpErrorResponse;
          const legacyNotFound = err instanceof Error && err.message === 'ERROR.USER_DONT_EXIST';
          if (httpErr.status === 404 || legacyNotFound) {
            this.toastr.error('No user found with this email. The user must sign up first.');
            this.modal.close();
            return;
          }

          const errBody = httpErr.error as { errors?: string[]; message?: string } | null;
          const message =
            (Array.isArray(errBody?.errors) && errBody.errors.length > 0
              ? errBody.errors.join(', ')
              : undefined) ??
            (typeof errBody?.message === 'string' ? errBody.message : undefined) ??
            httpErr.message;
          this.toastr.error(message);
        }
      );
  }
}
